import { api } from "@/builders/axios";
import { CreateRankData, RankData, Ranks } from "@/builders/types/ranks";

const list = function () {
  return api.get<Ranks>("ranks").then(({ data }) => data);
};

const post = function (data: CreateRankData) {
  return api.post("ranks", data).then(({ data }) => data);
};

const get = function (id: number) {
  return api.get<{ data: RankData }>(`ranks/${id}`).then(({ data }) => data);
};

const put = function (variables: { id: number; data: CreateRankData }) {
  const { id, data } = variables;
  return api.put(`ranks/${id}`, data).then(({ data }) => data);
};

const del = function (id: number) {
  return api.delete(`ranks/${id}`);
};

export const ranks = {
  list,
  post,
  get,
  put,
  del,
};
